class TabsContainer extends HTMLElement {
  #loadedScripts = new Set();

  constructor() {
    super();

    this.tabs = null;
    this.panel = null;
    this.indicator = null;
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-ref="tab"]');
    this.panel = this.querySelector('[data-ref="tabs-panel"]');
    this.indicator = this.querySelector('[data-ref="tabs-indicator"]');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.#resetTabs();
        this.#selectTab(tab);
      });
    });

    this.#selectTab(this.tabs[0]);

    // Maison Scarlett : affichage « Switch animé » — la pastille suit l'onglet actif
    if (this.indicator) {
      this.resizeObserver = new ResizeObserver(() => this.#moveIndicator());
      this.resizeObserver.observe(this.indicator.parentElement);
      // Pas d'animation au premier affichage : on active les transitions après le premier rendu
      setTimeout(() => this.classList.add('tabs--animated'), 100);
    }
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  #moveIndicator() {
    const activeTab = this.querySelector('[data-ref="tab"].active .tab__button');
    if (!this.indicator || !activeTab) return;

    this.indicator.style.setProperty('--indicator-x', `${activeTab.offsetLeft}px`);
    this.indicator.style.setProperty('--indicator-width', `${activeTab.offsetWidth}px`);
  }

  #selectTab(tab) {
    const tab_content = tab.querySelector('template').content.querySelector('[data-ref="tab-content"]');

    this.panel.innerHTML = tab_content.innerHTML;
    this.#activateScripts(this.panel);
    tab.classList.add('active');

    if (this.indicator) {
      this.#moveIndicator();
      this.panel.classList.remove('tabs__panel--entering');
      void this.panel.offsetWidth; // relance l'animation d'apparition du contenu
      this.panel.classList.add('tabs__panel--entering');
    }
  }

  #activateScripts(container) {
    for (const script of [...container.querySelectorAll('script')]) {
      const src = script.getAttribute('src');

      if (src) {
        if (this.#loadedScripts.has(src)) {
          script.remove();
          continue;
        }
        this.#loadedScripts.add(src);
      }

      const activeScript = document.createElement('script');

      for (const attr of script.attributes) {
        activeScript.setAttribute(attr.name, attr.value);
      }

      activeScript.textContent = script.textContent;
      script.replaceWith(activeScript);
    }
  }

  #resetTabs() {
    this.tabs.forEach((tab) => {
      tab.classList.remove('active');
    });
    this.panel.innerHTML = '';
  }
}

if (!customElements.get('tabs-container')) {
  customElements.define('tabs-container', TabsContainer);
}
